<template>
	<fragment>
		<ContractSignatures
			ref="contractSignaturesRef"
			:contract="contract"
			:saveContract="saveContract"
			:focusNextUnsignedInput="focusNextUnsignedInput"
		/>
		<InventoryList :contract="contract" />
		<InventoryListSignatures
			ref="inventoryListSignaturesRef"
			:contract="contract"
			:saveContract="saveContract"
			:focusNextUnsignedInput="focusNextUnsignedInput"
		/>
		<ContractActionButtons
			:contract="contract"
			:saveContract="saveContract"
		/>
	</fragment>
</template>

<script>
	import { Fragment } from 'vue-frag'
	import { mapActions } from 'vuex'
	import contractState from '../../../mixins/contractState'
	import InventoryList from '../sections/InventoryList.vue'
	import ContractSignatures from '../sections/ContractSignatures.vue'
	import InventoryListSignatures from '../sections/InventoryListSignatures.vue'
	import ContractActionButtons from '../sections/ContractActionButtons.vue'

	export default {
		name: 'Footer',
		components: {
			Fragment,
			InventoryList,
			ContractSignatures,
			InventoryListSignatures,
			ContractActionButtons
		},
		mixins: [contractState],
		props: {
			contract: {
				type: Object,
				required: true
			}
		},
		methods: {
			...mapActions(['sendEmail', 'signContract', 'getContract']),
			/**
			 * Focus the next unsigned input
			 */
			focusNextUnsignedInput() {
				const contractSignaturesRef = this.$refs.contractSignaturesRef
				const inventoryListSignaturesRef = this.$refs.inventoryListSignaturesRef

				// If contract does not have both signatures.
				if (contractSignaturesRef && (!this.signedByStaff || !this.signedByCustomer)) {
					contractSignaturesRef.focusNext()
				} else if (
					inventoryListSignaturesRef &&
					(!this.listSignedByStaff || !this.listSignedByCustomer)
				) {
					inventoryListSignaturesRef.focusNext()
				}
			},
			/**
			 * Save the contract with signature data
			 */
			async saveContract() {
				const updatedContract = {
					...this.contract
				}

				await this.updateContractData(updatedContract, {
					loadingMessage: this.isSubmittingSignature
						? 'Saving contract signatures...'
						: 'Saving contract...',
					successMessage: this.isSubmittingSignature
						? 'Contract signatures saved successfully'
						: 'Contract saved successfully',
					onSuccess: () => {
						this.isSubmittingSignature = false
					}
				})
			}
		}
	}
</script>

<style scoped></style>
